import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Suspense } from "react";
export var LazySearchPage = function LazySearchPage() {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LazySearchPageBase, null));
};
var LazySearchPageBase = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "search-page" */"./SearchPage").then(function (module) {
    return {
      "default": module.SearchPage
    };
  });
});